import { useEffect, useState } from "react";

export function useFrozenValue(value, shouldUpdate) {
  const [frozen, setFrozen] = useState(value);

  useEffect(() => {
    if (shouldUpdate) setFrozen(value);
  }, [value, shouldUpdate]);

  return frozen;
}
